import axios from 'axios';

export default {
  fetchAvContractList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/avContract', {
      params: paginationParams,
    })
      .then((avContracts) => {
        commit('setData', avContracts);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteAvContract(_, avContract) {
    return axios.delete(`/avContract/${avContract.id}`);
  },
  downloadReport(_, id) {
    console.log('params', id);

    return axios.get(`/avContract/report/${id}`, {
      responseType: 'blob',
      timeout: 30000,
    });
  },
};
